'use strict';

const { productKeyDisplayOption, clientProductKeyOption } = require('./filter-options');

const filterOptionFieldMapping = {
  [productKeyDisplayOption]: 'productKeyDisplay',
  [clientProductKeyOption]: 'clientProductKey',
};

const errorMapping = {
  missingStoreGroup: '(missing!)',
};

module.exports = {
  filterOptionFieldMapping,
  errorMapping,
};
